import CategoryIcon from '@mui/icons-material/Category';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Box from '@mui/material/Box';
import HistoryIcon from '@mui/icons-material/History';
import PersonIcon from '@mui/icons-material/Person';
import DashboardIcon from '@mui/icons-material/Dashboard';

import {
  MenuItemLink,
  MenuProps,
  usePermissions,
  useSidebarState,
} from 'react-admin';
import { People } from '@mui/icons-material';

const Menu = ({ dense = false }: MenuProps) => {
  const [open] = useSidebarState();

  const { permissions } = usePermissions();

  return (
    <Box
      sx={{
        width: open ? 200 : 50,
        marginTop: 1,
        marginBottom: 1,
        transition: (theme) =>
          theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <MenuItemLink
        to="/"
        primaryText="Главная"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<DashboardIcon />}
      />
      <MenuItemLink
        to="/models"
        primaryText="Дата модели"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<PersonIcon />}
      />
      {/* <MenuItemLink
        to="/chats"
        primaryText="Чаты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<PersonIcon />}
      />
      <MenuItemLink
        to="/jivo_chats"
        primaryText="Jivo чаты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<PersonIcon />}
      />
      <MenuItemLink
        to="/insales"
        primaryText="Insales"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<PersonIcon />}
      />
      <MenuItemLink
        to="/categories"
        primaryText="Категории"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<CategoryIcon />}
      />
      <MenuItemLink
        to="/products"
        primaryText="Продукты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<CategoryIcon />}
      />
      **/}
      <MenuItemLink
        to="/files"
        primaryText="Файлы"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<FileCopyIcon />}
      />
      {/* 
      {permissions === 'admin' && (
        <MenuItemLink
          to="/history"
          primaryText="История запросов"
          dense={dense}
          state={{ _scrollToTop: true }}
          leftIcon={<HistoryIcon />}
        />
      )}
      {permissions === 'admin' && (  */}
      {/* <MenuItemLink
        to="/feeds"
        primaryText="Ленты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      />
      <MenuItemLink
        to="/materials"
        primaryText="Материалы"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      />

      <MenuItemLink
        to="/material_tests"
        primaryText="Тесты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      />
      <MenuItemLink
        to="/digests"
        primaryText="Тренды"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      />
      <MenuItemLink
        to="/products"
        primaryText="Продукты"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      /> */}
      <MenuItemLink
        to="/users"
        primaryText="Пользователи"
        dense={dense}
        state={{ _scrollToTop: true }}
        leftIcon={<People />}
      />
      {/* )} */}
    </Box>
  );
};

// <MenuItemLink
//   to="/prompt/create"
//   primaryText="Промпт"
//   dense={dense}
//   state={{ _scrollToTop: true }}
//   leftIcon={<PersonIcon />}
// />
// <MenuItemLink
//   to="/prompt"
//   primaryText="История промптов"
//   dense={dense}
//   state={{ _scrollToTop: true }}
//   leftIcon={<TextSnippetIcon />}
// />
//
//
export default Menu;
